// @ts-nocheck
import { useEffect } from 'react'
import { usePlacesWidget } from 'react-google-autocomplete'
import { GOOGLE_MAPS_AUTOCOMPLETE_OPTIONS, GOOGLE_API_KEY } from 'utils/constants'

const GooglePlacesAutoComplete = ({ apiKey = GOOGLE_API_KEY, region, onPlaceSelected, renderTextField, onGooglePlacesReady, ...rest }) => {
	const { ref } = usePlacesWidget({
		apiKey,
		googleMapsScriptBaseUrl: `https://maps.googleapis.com/maps/api/js`,
		onPlaceSelected,
		options: {
			types: GOOGLE_MAPS_AUTOCOMPLETE_OPTIONS,
			componentRestrictions: { country: region || '' },
		},
		...rest,
	})

	useEffect(() => {
		if(onGooglePlacesReady) {
			const interval = setInterval(() => {
				if(window.google?.maps) {
					console.log('window.google.maps current is defined')
					clearInterval(interval)
					onGooglePlacesReady()
				}
			}, 100)

			return () => {
				clearInterval(interval)
			}
		}
	}, [])

	// This useEffect hides the autocomplete suggestions at the first component render,
	// then it displays them back when the user click or type on the input field.
	// It allows the input field (ref) to be programmatically focused, without displaying the address suggestions,
	// when, for example, the input field is already prefilled with a value.
	useEffect(() => {
		const styleEl = document.createElement('style')
		document.head.appendChild(styleEl)
		const styleSheet = styleEl.sheet
		styleSheet?.insertRule('.pac-container {display: none}', 0)

		const listener = () => {
			if (styleSheet?.cssRules.length > 0) {
				styleSheet?.deleteRule(0)
			}
			ref.current?.removeEventListener('click', listener)
			ref.current?.removeEventListener('input', listener)
		}

		ref.current?.addEventListener('click', listener)
		ref.current?.addEventListener('input', listener)

		return () => {
			if (styleSheet?.cssRules.length > 0) {
				styleSheet?.deleteRule(0)
			}

			ref.current?.removeEventListener('click', listener)
			ref.current?.removeEventListener('input', listener)
		}
	}, [])

	return renderTextField(ref)
}

export default GooglePlacesAutoComplete
